// export const rateCurrency: Array<Record<string, number>> = [
//   // Zone CEMAC (Franc CFA)
//   {"XAF": 1},            // Cameroun, Congo, Gabon, etc.

//   // Zone UEMOA (Franc CFA)
//   {"XOF": 1},            // Bénin, Burkina Faso, Côte d'Ivoire, Sénégal, Niger

//   // Afrique de l'Est et Centrale
//   {"MGA": 7.58},         // Madagascar (si supporté)
//   {"BIF": 5.33},         // Burundi
//   {"CDF": 4.02},         // République Démocratique du Congo
//   {"GNF": 15.4},         // Guinée
//   {"RWF": 2.6},          // Rwanda
//   {"KES": 0.0215},       // Kenya

//   // Afrique de l'Ouest
//   {"GHS": 0.0228},       // Ghana
//   {"NGN": 1.5},          // Nigéria
//   {"SLE": 0.033},        // Sierra Leone (nouvelle devise SLE)
//   {"MWK": 3.2},          // Malawi
//   {"MZN": 0.115},        // Mozambique
//   {"ZMW": 0.0285},       // Zambie
//   {"TZS": 4.5},          // Tanzanie
//   {"UGX": 6.8},          // Ouganda
//   {"ETB": 0.21},         // Éthiopie

//   // Afrique australe
//   {"LSL": 0.033},        // Lesotho (loti, lié au ZAR)
//   {"ZAR": 0.033},        // Rand sud-africain (pour Lesotho)

//   // Afrique du Nord (si supporté)
//   {"MAD": 0.0162},       // Maroc
//   {"DZD": 0.2304},       // Algérie
//   {"TND": 0.0051},       // Tunisie
//   {"DJF": 0.315},        // Djibouti

//   // Océan Indien (si supporté)
//   {"KMF": 0.75},         // Comores

//   // Devises internationales
//   {"USD": 0.00178598},   // Dollar américain
//   {"EUR": 0.00152449},   // Euro
// ];
export const rateCurrency: Array<Record<string, number>> = [
  { MGA: 7.58 },
  { BIF: 5.33 },
  { CDF: 4.02 },
  { GNF: 15.4 },
  { RWF: 2.6 },
  { MAD: 0.0162 },
  { DZD: 0.2304 },
  { TND: 0.0051 },
  { DJF: 0.315 },
  { KMF: 0.75 },
  { XAF: 1 },
  { XOF: 1 },
  { USD: 0.00178598 },
  { EUR: 0.00152449 },
];
